/*
 * MY.LAB — frise des étapes : le rail se remplit au défilement.
 *
 * Le remplissage suit une ligne placée aux deux tiers de la fenêtre. Chaque
 * étape dont la pastille est passée sous ce niveau reçoit `is-atteinte`.
 * Rien ne s'active si l'utilisateur a demandé à réduire les animations : le
 * rail reste plein et les pastilles jaunes, comme sans JavaScript.
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function brancher(racine) {
    var frise = racine.querySelector('.ml-pe__frise');
    var rail = racine.querySelector('.ml-pe__rail');
    var etapes = Array.prototype.slice.call(racine.querySelectorAll('.ml-pe__etape'));
    if (!frise || !rail || !etapes.length) return;

    racine.classList.add('ml-pe--anime');
    var enAttente = false;

    function mettreAJour() {
      enAttente = false;
      var haut = rail.getBoundingClientRect().top;
      var hauteur = rail.offsetHeight;
      var niveau = window.innerHeight * 0.66 - haut;
      var plein = Math.max(0, Math.min(hauteur, niveau));
      racine.style.setProperty('--pe-plein', plein + 'px');
      etapes.forEach(function (etape) {
        var pastille = etape.querySelector('.ml-pe__num');
        if (!pastille) return;
        var centre = pastille.getBoundingClientRect().top + pastille.offsetHeight / 2;
        etape.classList.toggle('is-atteinte', centre <= window.innerHeight * 0.66);
      });
    }

    function demander() {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(mettreAJour);
    }

    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', demander);
    mettreAJour();
  }

  function demarrer() {
    document.querySelectorAll('[data-ml-pe]').forEach(brancher);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
